export default "__VITE_ASSET__M$N3aj4q__"